class ShippingProgressBar extends HTMLElement {
  connectedCallback() {
    this.goal = parseInt(this.dataset.goal, 10) || 0;
    this.dynamicMessage = this.dataset.dynamicMessage || '';
    this.successMessage = this.dataset.successMessage || '';
    this.renderBar = this.renderBar.bind(this);

    document.addEventListener('cart:update', this.renderBar);
    this.renderBar();
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this.renderBar);
  }

  getCartSubtotal() {
    // Prefer window.Shopify.cart if available, fallback to data attribute
    if (window.Shopify && window.Shopify.cart) {
      return window.Shopify.cart.total_price || 0;
    }
    return parseInt(this.dataset.cartSubtotal, 10) || 0;
  }

  formatMoney(cents) {
    // Adjust this for your currency formatting if needed
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  renderBar() {
    const subtotal = this.getCartSubtotal();
    const remaining = Math.max(this.goal - subtotal, 0);
    const percent = Math.min(Math.round((subtotal / this.goal) * 100), 100);

    let message = '';
    if (remaining > 0) {
      message = this.dynamicMessage.replace('$$', this.formatMoney(remaining));
    } else {
      message = this.successMessage;
    }

    this.innerHTML = `
      <span class="shipping-progress-bar__title">${message}</span>
      <div class="shipping-progress-bar__progress-bar">
        <div class="shipping-progress-bar__progress-bar-percentage" style="width: ${percent}%;"></div>
      </div>
    `;
  }
}

customElements.define('shipping-progress-bar', ShippingProgressBar);